import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { CentroCustosService } from 'src/app/services/centro-custos.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-cadastro-centro-custos',
    templateUrl: './modal-cadastro-centro-custos.component.html',
    providers: [CentroCustosService]
})

export class ModalCadastroCentroCustosComponent implements OnInit {

    modalRef: NgbModalRef;
    public centroCusto: any;

    constructor(
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private appService: AppService,
        private centroCustosService: CentroCustosService,
        private dadosCargasService: DadosCargasService,
    ) {

    }

    popularNovoCentroCusto() {
        this.centroCusto = {
            nome: '',
            classificacao: '',
        };
    }

    ngOnInit(): void {
        this.popularNovoCentroCusto();
    }

    cadastrar() {
        this.add(this.centroCusto);
    }

    add(centroCusto) {
        this.spinner.show();
        this.toastrService.clear();
        this.centroCustosService.add(centroCusto)
            .subscribe(res => {
                this.toastrService.success("Centro de Custo cadastrado.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'cadastrado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível cadastrar o centro de custo!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}